export default __webpack_public_path__ + "static/media/paypal-logo.7ac6c949.jpg";